import { getTimeslotsFromFilter } from "../../../utils/timeslots";

export type AdminStatsQueryFilters = {
    timeslotFilter?: string;
    challengeFilter?: string;
    tags?: string[];
    roles?: string[];
    favoritesOnly?: boolean;
};

export type AdminStatsQueryInput = {
    startDate: string;
    endDate: string;
    timeslots?: string;
    tagIds?: string;
    isChallenge?: boolean;
    rolesIds?: string;
    favoritesOnly?: boolean;
};

export const buildAdminStatsQueryInput = (
    startDate: string,
    endDate: string,
    filters: AdminStatsQueryFilters = {}
): AdminStatsQueryInput => {
    const timeslotsArray = getTimeslotsFromFilter(filters.timeslotFilter);
    const timeslots = timeslotsArray ? timeslotsArray.join(",") : undefined;
    const tagIds =
        filters.tags && filters.tags.length > 0
            ? filters.tags.join(",")
            : undefined;
    const rolesIds =
        filters.roles && filters.roles.length > 0
            ? filters.roles.join(",")
            : undefined;

    let isChallenge: boolean | undefined;
    if (filters.challengeFilter === "only") {
        isChallenge = true;
    } else if (filters.challengeFilter === "exclude") {
        isChallenge = false;
    }

    return {
        startDate,
        endDate,
        ...(timeslots && { timeslots }),
        ...(tagIds && { tagIds }),
        ...(isChallenge !== undefined && { isChallenge }),
        ...(rolesIds && { rolesIds }),
        ...(filters.favoritesOnly && { favoritesOnly: filters.favoritesOnly }),
    };
};
